/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function () {
  'use strict';
  /**
   * Общий вид страницы товаров претензий
   */
  app.ClaimItemFormView = app.ClaimUploadFormView.extend({
    formElement: '.field, .input-fake',
    events: {
      'click .js-claim-parent': 'changeOrderInvoiceTab',
      'click .order_id': 'openOrdersPopup',
      'blur .order_id': 'updateOrderNumber',
      'blur .invoice_number': 'updateInvoiceNumber',
      'blur .sid': 'updateItemSid',
      'blur .qty-count, .qty input, .not-full input': 'updateQty',
      'blur .received input': 'updateReceivedQty',
      'blur .ordered input': 'updateOrderedQty',
      'blur .claim-edit-comment textarea': 'updateComment',
      'click .photo-remove': 'removePhoto',
      'change .fileupload': 'photoUpload',
      'keyup .claim-qty input': 'inputKeyUp',
      'click .switcher li': 'selectOption',
      'click .change-value': 'changeQty',
      'click .claim-save': 'validateModel',
      'click .claim-cancel': 'claimCancel',
      'click .js-damage-select, .js-damage-select-opener': 'toggleDamageList',
      'mousedown .js-damage-option': 'selectDamageOption',
      'blur .js-damage-select': 'hideDamageList',
      'keypress .sid': 'preventNonDigitInput',
    },
    DAMAGE_TYPE_ID: 2,
    run: function () {
      app.ClaimUploadFormView.prototype.run.apply(this, arguments);
      this.template = app.helpers.TemplateHelper.getTemplate('#newest-claim-item');
      this.orderAndInvoiceClaimTemplate = app.helpers.TemplateHelper.getTemplate('#order-and-invoice-claim-template');
      this.photoTemplate = app.helpers.TemplateHelper.getTemplate('#photo-template');
      this.damageTypesTemplate = app.helpers.TemplateHelper.getTemplate('#js-damage-template');
      this.packagingTypesTemplate = app.helpers.TemplateHelper.getTemplate('#js-packaging-types-template');
      this.notLoaded = [];
      this.isSaving = false;
      this.orders = new app.Order();
      this.claimTipsEnabled = app.features.is_claim_tips_enabled;
    },
    render: function (element, notReplace) {
      var orderOrInvoiceLink = this.$('.order-and-invoice-block .claim-edit-label.link');
      if (!element) {
        element = $(this.template({
          model: this._prepareModelDataForRender(),
          isOrderLink: orderOrInvoiceLink.hasClass('order-number'),
        }));
        if (!notReplace) {
          this.$el.replaceWith(element);
        }
      }
      this.setElement(element);
      if (this.collection.length <= 1 && !this.model.get('id')){
        this.$('.js-popup-close').addClass('not_display');
        this.$('.claim-cancel').addClass('not_display');
      }
      this.initOrdersPopup();
      this.initTips();

      if (this.model.get('id')) {
        if (this.model.get('invoice_number')) {
          this.openOrderInvoiceField('invoice');
        } else {
          this.openOrderInvoiceField('order');
        }
      }
      this.prepareDamageCollections(this.model.get('claim_item_reason_id'));
      if (this.savedInvoiceNumber) {
        this.model.set('invoice_number', this.savedInvoiceNumber);
        this.$('.input.invoice_number').val(this.savedInvoiceNumber);
      } else if (this.savedOrderNumber) {
        this.model.set('order_id', this.savedOrderNumber);
        this.$('.input.order_id').val(this.savedOrderNumber);
      }
      return this;
    },
    /**
     * Предотвращает ввод в поле нецифровых символов
     * @param {Event} event Событие нажатия клавиши в поле
     */
    preventNonDigitInput: function (event) {
      if (event.keyCode < 48 || event.keyCode > 57) {
        // Предотвращаем поведение по-умолчанию для всех клавиш кроме цифр
        event.preventDefault();
      }
    },
    /**
     * Инициализация попапа с номерами заказов
     */
    initOrdersPopup: function () {
      this.orderNumbers = new app.ClaimOrderNumbersView({
        el: this.$('.order-numbers'),
      });
      this.listenTo(this.orderNumbers, 'selectOtherOrder', this.setOrderNumber);
    },
    /**
     * Инициализация вью подсказок по товарам и заказам
     */
    initTips: function () {
      if (this.claimTipsEnabled) {
        this.childViews.orderTips = new app.ClaimFormTipsView({
          el: this.$('.claim-edit-invoice'),
          templateName: '#claim-orders-dropdown',
          url: '/iapi/claim-tips/v1/orders',
          getParams: function () {
            var params = {};
            if (this.model.get('sid')) {
              params.product_sid = this.model.get('sid');
            }
            return params;
          }.bind(this),
          getTipValue: function (tip) {
            return tip.id;
          },
        });
        this.childViews.productTips = new app.ClaimFormTipsView({
          el: this.$('.claim-edit-sid'),
          templateName: '#claim-products-dropdown',
          url: '/iapi/claim-tips/v1/products',
          getParams: function () {
            var params = {};
            if (this.model.get('order_id')) {
              params.order_id = this.model.get('order_id');
            }
            return params;
          }.bind(this),
          getTipValue: function (tip) {
            return tip.sid;
          },
        });
      }
    },
    /**
     * подготовка модели к рендеру
     * @private
     */
    _prepareModelDataForRender: function () {
      var modelData = this.model.toJSON();
      if (!_.isArray(modelData.photos)) {
        modelData.photos = [];
      }
      if (this.notLoaded && this.notLoaded.length) {
        _.each(this.notLoaded, function (data) {
          modelData.photos.push({
            url: window.URL.createObjectURL(data.get('file_path'))
          });
        });
      }
      return modelData;
    },
    /**
     * Выбор опции
     * @param e
     */
    selectOption: function (e) {
      e.preventDefault();
      e.stopPropagation();
      var target = $(e.target),
        selectedOption = target.text(),
        selectedId = target.data('select-id');

      if (selectedId === undefined) {
        selectedId = 1;
      }
      this.updateFieldsList();
      var key = {
        'claim_item_reason_id': selectedId,
        'claim_item_reason_title': selectedOption
      };
      this.$(e.currentTarget).find('input').prop({'checked': true});
      this.model.set(key);
      this.render();
    },

    /**
     * Вызываем методы заполнения коллекция для вкладки "Брак".
     * @param {number} selectedId Id выбранной вкладки причины.
     */
    prepareDamageCollections: function (selectedId) {
      if (selectedId === this.DAMAGE_TYPE_ID) {
        this.fetchDamageReasonTypes();
        this.fetchClaimPackagingTypes();
      } else {
        this.selectDamageOption(null);
      }
    },

    /**
     * Сбрасываем количество до единицы.
     * @param e
     */
    resetQty: function (e) {
      var $target = $(e.target),
        $parent = $($target.parents('.claim-qty-btn')),
        key,
        value = 1;
      $target.siblings('input').val(1);
      if ($parent.hasClass('ordered')) {
        key = 'ordered';
      } else if ($parent.hasClass('received')) {
        key = 'received';
      } else {
        key = 'qty';
      }
      this.model.set(key, value);
    },
    /**
     * Обновление номера заказа
     * @param {Event} event Событие при оставлении поля номера заказа
     */
    updateOrderNumber: function(event) {
      var value = $(event.target).val().trim();
      this.setOrderNumber(value);
      if (this.claimTipsEnabled) {
        this.childViews.orderTips.remove();
        if (value && !this.model.get('sid')) {
          this.childViews.productTips.autocomplete();
        }
      }
    },
    /**
     * Обновление номера накладной в модели.
     * @param {Event} event Событие при оставлении поля номера накладной
     */
    updateInvoiceNumber: function (event) {
      var value = $(event.target).val();
      this.setInvoiceNumber(value);
    },
    /**
     * Обновление артикула товара в модели.
     * @param {Event} event Событие при оставлении поля артикула
     */
    updateItemSid: function (event) {
      var key = 'sid',
        value = $(event.target).val(),
        lastValue = this.model.get(key);

      this.claimTipsEnabled && this.childViews.productTips.remove();
      if (lastValue ? value !== lastValue.toString() : value) {
        this.model.set(key, value);
        if (this.claimTipsEnabled) {
          if (value && !this.model.get('order_id')) {
            this.childViews.orderTips.autocomplete();
          }
        } else {
          this.updateOrders(value);
        }
      }
    },
    /**
     * Обновление модели заказов
     * @param {string} sid Строковое значение введенного пользователем артикула
     */
    updateOrders: function (sid) {
      var that = this;
      this.orders.clear();
      this.setOrderNumber(null);
      this.setInvoiceNumber(null);
      this.orders.fetch({
        data: {
          item_sid: sid,
          sort: '-created_at',
          success: 1,
        },
        success: function (data) {
          that.prepareOrdersData(data.get('items'));
        },
      });
    },
    /**
     * Подготовка номера заказа для подстановки в соответствующее поле
     * @param {Array} orders Массив заказов
     */
    prepareOrdersData: function (orders) {
      if (_.isArray(orders) && !_.isEmpty(orders)) {
        this.setOrderNumber(orders[0].id);
      }
    },
    /**
     * Установка номера заказа в поле и модель
     * @param {null|number|string} orderId Значение номера заказа
     */
    setOrderNumber: function (orderId) {
      this.$('.order_id').val(orderId);
      this.model.set('order_id', orderId);
      this.savedOrderNumber = orderId;
    },
    /**
     * Установка номера накладной в поле и модель
     * @param {null|number|string} invoiceId Значение номера накладной
     */
    setInvoiceNumber: function (invoiceId) {
      this.$('.invoice_number').val(invoiceId);
      this.model.set('invoice_number', invoiceId);
      this.savedInvoiceNumber = invoiceId;
    },
    /**
     * Открытие попапа с номерами заказов
     */
    openOrdersPopup: function() {
      var orders = this.orders.get('items'),
        currentOrderId = this.model.get('order_id');
      if (orders && orders.length > 1) {
        this.orderNumbers.render(orders, currentOrderId);
      }
    },
    /**
     * Переключение номера заказа / номера накладной
     * @param {Event} event Событие клика по вкладке
     */
    changeOrderInvoiceTab: function (event) {
      var type = $(event.target).data('type');
      if (!this.model.get('id')) {
        this.model.set('order_id', null);
        this.model.set('invoice_number', null);
      }
      this.openOrderInvoiceField(type);
    },
    /**
     * Открытие соответствующего поля ввода номера заказа / накладной
     * @param {string} type Тип вкладки
     */
    openOrderInvoiceField: function (type) {
      var isOrderTab = type === 'order';
      this.orderNumbers.toggle(false);
      this.$('.order-and-invoice-block').html(this.orderAndInvoiceClaimTemplate({
        model: this.model,
        isOrder: isOrderTab,
      }));
      this.$('.order-comment').toggleClass('not_display', !isOrderTab);
      this.$('.invoice-comment').toggleClass('not_display', isOrderTab);
      this.$('.order_id-error').toggleClass('not_display', !isOrderTab);
      this.$('.invoice_number-error').toggleClass('not_display', isOrderTab);
      if (type === 'order' && this.savedOrderNumber)  {
        this.$('.order-and-invoice-block input').val(this.savedOrderNumber);
      } else if (type === 'invoice' && this.savedInvoiceNumber) {
        this.$('.order-and-invoice-block input').val(this.savedInvoiceNumber);
      }
    },
    /**
     * Обновление колличества товара в модели.
     * @param e
     */
    updateQty: function (e) {
      var input = e.target ? $(e.target) : e,
        value = input.val(),
        key = 'qty';
      if (value <= 0) {
        input.val(1);
        value = 1;
      }
      this.model.set(key, value);
    },
    updateReceivedQty: function (e) {
      var input = e.target ? $(e.target) : e,
        value = Number(input.val()),
        key = 'received_qty',
        condition = this.model.get('claim_item_reason_id') === 3 ? 0 : 1;
      /* если причина недовложение, количество может быть нулевым */
      if (value < condition || !value) {
        input.val(condition);
        value = condition;
      }
      this.model.set(key, value);
    },
    updateOrderedQty: function (e) {
      var input = e.target ? $(e.target) : e,
        value = Number(input.val()),
        key = 'ordered_qty',
        condition = this.model.get('claim_item_reason_id') === 5 ? 0 : 1;
      /* если причина излишки, количество может быть нулевым */
      if (value < condition || !value) {
        input.val(condition);
        value = condition;
      }
      this.model.set(key, value);
    },
    /**
     * Обновление комментария в модели.
     * @param e
     */
    updateComment: function (e) {
      var key = 'comment',
        value = $(e.target).val();
      this.model.set(key, value);
    },
    /**
     * Сохранение свойства в модели.
     * @param key
     * @param value
     */
    saveModel: function (key, value) {
      this.isSaving = true;
      var that = this,
        options = {
          success: function () {
            that.clearErrors();
            that.model.set('valid', true);
            that.isSaving = false;
            // проверяем, есть ли незагруженные фотки
            if (that.notLoaded.length) {
              var loaded = [];
              var deferred = that.notLoaded.map(function (photoForm) {
                photoForm.append('claim_item_id', that.model.get('id'));
                return that.postFormData(photoForm, loaded);
              });
              that.notLoaded = [];
              // после того как все запросы закончатся выполняем рендер
              $.when.apply($, deferred).then(function () {
                that.model.set('photos', loaded);
                Backbone.trigger('item-view-saved');
                if (that.isOpenNewItem) {
                  Backbone.trigger('open-more-claim-item');
                }
              }, function () {
                that.$('.js-claim-save').prop('disabled', false);
                that.model.set('valid', false);
                that.isSaving = false;
              });
            } else {
              Backbone.trigger('item-view-saved');
              if (that.isOpenNewItem) {
                Backbone.trigger('open-more-claim-item');
              }
            }
          },
          error: function (model, response) {
            if (that.showError) {
              that.$('.js-claim-save').prop('disabled', false);
              var orderError = _.find(response.responseJSON, {field: 'order_id'}),
                invoiceError = _.find(response.responseJSON, {field: 'invoice_number'});
              if (orderError || invoiceError) {
                that.openOrderInvoiceField(orderError ? 'order' : 'invoice');
              }
              that.error(model, response);
            }
            that.model.set('valid', false);
            that.isSaving = false;
          }
        };
      if (key === null || typeof key === 'object') {
        value = options;
      }
      this.savePackagingTypes();
      this.$fields = this.$el.find(this.formElement);
      return this.model.save(key, value, options);
    },
    /**
     * Удаление добавленной фотографии.
     * @param e
     */
    removePhoto: function (e) {
      var $parent = $(e.target).parents('.claim-photo-block'),
        allPhotos = this.$('.photo-thumbnails').children(),
        index = allPhotos.index($parent),
        id = $parent.data('photo-id'),
        photosArray = this.model.get('photos');
      if (!id) {
        this.notLoaded.splice(index, 1);
        $parent.remove();
      }
      // если фотки еще нет на сервере, не нужно отправлять запрос на удаление
      if (id) {
        $.ajax({
          url: '/api/v3/claim-item-photo/' + id + '/',
          method: 'DELETE'
        }).done(function () {
          photosArray.splice(index, 1);
          this.model.set('photos', photosArray);
          $parent.remove();
        }.bind(this));
      }
    },
    /**
     * Заполнение ошибок
     * @param {array} errors массив ошибок формы
     */
    fillErrors: function (errors) {
      var that = this;
      errors.forEach(function (error) {
        that.$('.' + error.field + '-error').text(error.message);
        if (error.field === 'ordered_qty') {
          that.$('.claim-qty-block.ordered .input-fake').addClass('error');
          that.$('.claim-qty-block.received .input-fake').addClass('error');
        } else {
          that.$('.' + error.field).addClass('error');
          if (error.field === 'comment') {
            that.$('.claim-comment-message').addClass('red-comment');
          }
        }
      });
    },
    /**
     * Очистка ошибок
     */
    clearErrors: function () {
      this.$fields.each(function () {
        $(this).removeClass('error');
      });
      this.$('.error-message').text('');
      this.$('.comment-message').removeClass('red-comment');
      this.$('.fileupload').show();
    },
    /**
     * Сохранение модели на сервер и показ ошибок.model.set
     * @param {Event} event Событие клика на кнопки 'Сохранить изменения'/'Добавить еще товар'
     * @returns {promise}
     */
    validateModel: function (event) {
      this.$('.js-claim-save').prop('disabled', true);
      this.isOpenNewItem = $(event.currentTarget).hasClass('open-new-item');
      this.showError = true;
      return this.saveModel(null);
    },
    /**
     * Вырезаем в поле ввода любые символы кроме цифр.
     */
    inputKeyUp: function (e) {
      var $input = $(e.target);
      $input.val($input.val().replace(/([^0-9])/g, ''));
    },
    /**
     * Проверяем, валидны ли заполненные поля, прежде чем загружать фото,
     * если запрос уже ушел, ничего не делаем.
     */
    checkPhotoLoad: function () {
      if (!this.isSaving) {
        this.validateModel();
      }
    },
    /**
     * Изменение значений кнопками (+-)
     * @param e
     */
    changeQty: function (e) {
      var $target = $(e.currentTarget),
        input = $target.offsetParent().find('input'),
        numb = input.val();
      if ($target.hasClass('plus')) {
        numb++;
      } else {
        numb--;
      }
      input.val(numb);
      if (input.hasClass('qty-count')) {
        this.updateQty(input);
      } else if (input.hasClass('ordered_qty')) {
        this.updateOrderedQty(input);
      } else {
        this.updateReceivedQty(input);
      }
    },
    /**
     * Отмена заполнения
     */
    claimCancel: function () {
      Backbone.trigger('item-view-cancel-popup');
    },

    /**
     * Показать список типов повреждений.
     */
    showDamageList: function () {
      this.select = this.$('.js-damage-select-options');
      this.select.find('.select-popup').removeClass('not_display');
      this.$('.select-arrow').addClass('arrow_up');
      this.isOpen = true;
    },

    /**
     * Скрыть список типов повреждений.
     */
    hideDamageList: function () {
      this.select = this.$('.js-damage-select-options');
      this.select.find('.select-popup').addClass('not_display');
      this.$('.select-arrow').removeClass('arrow_up');
      this.isOpen = false;
    },

    /**
     * Показать/cкрыть список типов повреждений.
     */
    toggleDamageList: function () {
      if (!this.isOpen) {
        this.showDamageList();
      } else {
        this.hideDamageList();
      }
    },

    /**
     * Выбор опции из списка типов повреждений.
     * @param {object} e
     */
    selectDamageOption: function (e) {
      if (e === null) {
        this.model.unset('claim_item_reason_type_id');
        return;
      }
      e.preventDefault();

      var target = $(e.target);
      var selectedOption = target.text();
      var id = target.data('id');

      this.selectInput = this.$('.js-damage-select');
      this.selectInput.val(selectedOption);
      this.hideDamageList();
      if (id === undefined) {
        id = '';
      }

      this.model.set({
        claim_item_reason_type_id: id
      });
    },

    /**
     * Сохранение выбранных типов упаковки.
     */
    savePackagingTypes: function () {
      var selectedIds = [];
      var activeCheckboxes = this.$('.js-packaging-types-wrapper input:checked');
      if (activeCheckboxes.length) {
        activeCheckboxes.each(function (i, checkbox) {
          var id = $(checkbox).data('id');
          if (id) {
            selectedIds.push(id);
          }
        });
        this.model.set({
          packaging_type_ids: selectedIds,
        });
      } else {
        this.model.unset('packaging_type_ids');
      }
    },

    /**
     * Заполнение коллекции типов повреждений.
     */
    fetchDamageReasonTypes: function () {
      if (!this.reasonTypes) {
        this.reasonTypes = new app.Collection();
        this.reasonTypes.url = app.entryScriptName
          + '/api/v3/claim-item-reason-type/?reason_id=' + this.DAMAGE_TYPE_ID;
        this.reasonTypes.fetch({
          success: this.renderDamageReasons.bind(this)
        });
      } else {
        this.renderDamageReasons(this.reasonTypes);
      }
    },

    /**
     * Заполнение коллекции типов упаковки.
     */
    fetchClaimPackagingTypes: function () {
      if (!this.packagingTypes) {
        this.packagingTypes = new app.Collection();
        this.packagingTypes.url = app.entryScriptName
          + '/api/v3/claim-item-packaging-type/?reason_id=' + this.DAMAGE_TYPE_ID;
        this.packagingTypes.fetch({
          success: this.renderPackagingTypes.bind(this)
        });
      } else {
        this.renderPackagingTypes(this.packagingTypes);
      }
    },

    /**
     * Отрисовка списка типов повреждений.
     * @param {app.Collection} collection Коллекция типов повреждений.
     */
    renderDamageReasons: function (collection) {
      if (collection.length) {
        var damageReasons = collection.toJSON();
        var selectedReason = _.find(damageReasons, {
          id: this.model.get('claim_item_reason_type_id'),
        });
        this.$('.js-damage-types-field').html(this.damageTypesTemplate({
          claimReasonTypes: damageReasons,
          selectedName: (selectedReason && selectedReason.name) || '',
        }));
      }
    },

    /**
     * Отрисовка списка типов упаковки.
     * @param {app.Collection} collection Коллекция типов упаковки.
     */
    renderPackagingTypes: function (collection) {
      if (collection.length) {
        var selectedIds = [];
        var packagingIds = this.model.get('packaging_type_ids');
        if (Array.isArray(packagingIds)) {
          selectedIds = packagingIds;
        }
        var packagingTypes = collection.toJSON().map(
          //если тип находится в списке выбранных, добавляем ему признак isSelected
          function (type) {
            if (Array.isArray(selectedIds) && selectedIds.indexOf(type.id) !== -1) {
              type.isSelected = true;
            }
            return type;
          }
        );

        this.$('.js-packaging-types-wrapper').html(this.packagingTypesTemplate({
          packagingTypes: packagingTypes,
        }));
      }
    },
  });
})(jQuery);

}.call(window));